export enum FileActionTypes {
  SET_FILE = "@@FILE/SET_FILE",
}
